import React from 'react';
import styled from 'styled-components';
import tw from 'twin.macro';
import Skeleton from '../Skeleton';

const PageContainer = styled.div`
  ${tw`p-4 bg-bg-secondary min-h-screen max-w-full min-w-0 box-border`}
`;

const TitleSkeleton = styled(Skeleton)`
  ${tw`h-8 w-48 mb-6`}
`;

const BookingList = styled.div`
  ${tw`space-y-4 max-w-4xl mx-auto`}
`;

const BookingCard = styled.div`
  ${tw`bg-white rounded-lg shadow-card`}
`;

const BookingHeader = styled.div`
  ${tw`p-4 border-b border-border-default`}
`;

const StatusSkeleton = styled(Skeleton)`
  ${tw`h-6 w-24 rounded-full`}
`;

const BookingBody = styled.div`
  ${tw`p-4`}
`;

const DateRangeSkeleton = styled(Skeleton)`
  ${tw`h-4 w-64 mb-2`}
`;

const CarInfo = styled.div`
  ${tw`flex items-center gap-4`}
`;

const CarImageSkeleton = styled(Skeleton)`
  ${tw`w-20 h-16 rounded-md`}
`;

const CarDetails = styled.div`
  ${tw`flex-1`}
`;

const CarNameSkeleton = styled(Skeleton)`
  ${tw`h-6 w-48 mb-2`}
`;

const LocationSkeleton = styled(Skeleton)`
  ${tw`h-4 w-full max-w-md mb-1`}
`;

const GuestInfo = styled.div`
  ${tw`mt-3 pt-3 border-t border-border-default`}
`;

const GuestInfoSkeleton = styled(Skeleton)`
  ${tw`h-4 w-32 mt-3`}
`;

const BookedMyCarsPageSkeleton: React.FC = () => {
  return (
    <PageContainer>
      <TitleSkeleton />

      <BookingList>
        {Array(4)
          .fill(0)
          .map((_, index) => (
            <BookingCard key={index}>
              <BookingHeader>
                <StatusSkeleton />
              </BookingHeader>
              <BookingBody>
                <DateRangeSkeleton />
                <CarInfo>
                  <CarImageSkeleton />
                  <CarDetails>
                    <CarNameSkeleton />
                    <LocationSkeleton />
                    <LocationSkeleton width="90%" />
                    <GuestInfo>
                      <GuestInfoSkeleton />
                    </GuestInfo>
                  </CarDetails>
                </CarInfo>
              </BookingBody>
            </BookingCard>
          ))}
      </BookingList>
    </PageContainer>
  );
};

export default BookedMyCarsPageSkeleton;
